export const language = localStorage.getItem("language");
